module.exports = __webpack_public_path__ + "static/media/Notification-ReadyToShip-Push-Preview.8f74c2a4.png";